import { io } from "socket.io-client";
import { SOCKET_URL } from "../api/baseUrl";

export const socket = io(`${SOCKET_URL}`);
export const connectToSocket = () => {
  socket.on("connect", () => {
    console.log("User Connect to socket using:", socket.id); // x8WIv7-mJelg7on_ALbx
  });
};
